// The Internal Review: the routes of `dowgate.onboarding.internal-review` (SEP-293 section 7, ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'dowgate.onboarding.internal-review',
    routes: [
        // The client answers the clarification requests of the investment
        // manager about the fact find.
        {
            frontend: 'portal',
            path: 'clarifications',
            lazy: () => import('@/pages/portal/clarifications/page'),
        },
    ],
});
